export default __webpack_public_path__ + "static/GalileoOG-70318a644e68f79c8e7869ad93f4d4d3.jpg";